var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 12.0216H24.0013V0.281738C17.5308 0.281738 12.2656 5.5488 12.2656 12.0216Z",
    fill: "#E91E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2656 12.0217C12.2656 18.5157 17.5308 23.7616 24.0013 23.7616V12.0217H12.2656Z",
    fill: "#3F51B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0217V23.7616C6.49163 23.7616 11.7357 18.4945 11.7357 12.0217H0Z",
    fill: "#FF5733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7357 12.0216H0V0.281738C6.49163 0.281738 11.7357 5.5488 11.7357 12.0216Z",
    fill: "#673AB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany10);
export default __webpack_public_path__ + "static/media/company-10.6240d6a6073f3f3872dba7941090e2a4.svg";
export { ForwardRef as ReactComponent };